function initAtlasHeader(shell) {
  if (!shell || shell.dataset.stickyReady === 'true') return;

  const promo = shell.querySelector('.atlas-promo');
  const navWrap = shell.querySelector('.atlas-nav-wrap');
  if (!promo || !navWrap) return;

  shell.dataset.stickyReady = 'true';
  const pageWrapper = shell.closest('.page-wrapper');
  let threshold = 0;
  let ticking = false;

  const usePageWrapper = () => window.matchMedia('(min-width: 990px)').matches && pageWrapper;
  const scrollTop = () => (usePageWrapper() ? pageWrapper.scrollTop : window.scrollY);

  const measure = () => {
    navWrap.classList.remove('atlas-nav-wrap--fixed');
    if (usePageWrapper()) {
      threshold =
        shell.getBoundingClientRect().top - pageWrapper.getBoundingClientRect().top + pageWrapper.scrollTop + promo.offsetHeight;
    } else {
      threshold = shell.getBoundingClientRect().top + window.scrollY + promo.offsetHeight;
    }
    update();
  };

  const update = () => {
    navWrap.classList.toggle('atlas-nav-wrap--fixed', scrollTop() >= threshold);
    ticking = false;
  };

  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  };

  window.addEventListener('scroll', requestUpdate, { passive: true });
  pageWrapper?.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', measure, { passive: true });
  measure();
}

function initAllAtlasHeaders(root = document) {
  root.querySelectorAll('.atlas-header-shell').forEach(initAtlasHeader);
}

initAllAtlasHeaders();
document.addEventListener('shopify:section:load', (event) => initAllAtlasHeaders(event.target));
